import { dashMetaJson } from '../../../shared/api/dash-meta-fetch';
import type { Page } from '../components/PageConfigProvider/types';
import { migrateLegacyGauges } from '../components/PageConfigProvider/utils/migrate-legacy-gauge';
import type { ReportRun } from '../components/Reports/types';
import { deserializePageDimensionSources } from '../utils/dimension-source-serialization';

const deserializePage = (page: Page): Page =>
  migrateLegacyGauges(deserializePageDimensionSources(page));

//
// Build a Dash Pages
//
export const getPages = async (userId?: string) => {
  const base = '/api/build-a-dash/pages';
  const path = userId ? `${base}?userId=${encodeURIComponent(userId)}` : base;
  const pages = await dashMetaJson<Page[]>(path, { method: 'GET' });
  return pages.map(deserializePage);
};

export const getPage = async (pageId: string) => {
  const page = await dashMetaJson<Page>(`/api/build-a-dash/pages/${pageId}`, {
    method: 'GET',
  });
  return deserializePage(page);
};

export const createPage = (page: Page) =>
  dashMetaJson<Page>('/api/build-a-dash/pages', {
    method: 'POST',
    body: JSON.stringify(page),
  });

export const updatePage = (pageId: string, page: Partial<Page>) =>
  dashMetaJson<Page>(`/api/build-a-dash/pages/${pageId}`, {
    method: 'PUT',
    body: JSON.stringify(page),
  });

export const deletePage = (pageId: string) =>
  dashMetaJson<boolean>(`/api/build-a-dash/pages/${pageId}`, {
    method: 'DELETE',
  });

//
// Build a Dash Report Runs
//
export const createReportRun = (reportRun: Omit<ReportRun, 'id'>) =>
  dashMetaJson<ReportRun>('/api/build-a-dash/report-runs', {
    method: 'POST',
    body: JSON.stringify(reportRun),
  });

export const updateReportRun = (runId: string, reportRun: Partial<ReportRun>) =>
  dashMetaJson<ReportRun>(`/api/build-a-dash/report-runs/${runId}`, {
    method: 'PUT',
    body: JSON.stringify(reportRun),
  });

export const deleteReportRun = (runId: string) =>
  dashMetaJson<void>(`/api/build-a-dash/report-runs/${runId}`, {
    method: 'DELETE',
  });

export const getReportRuns = (ownerId: string) =>
  dashMetaJson<Omit<ReportRun, '_id'>[]>(
    `/api/build-a-dash/report-runs/owner/${ownerId}`,
    {
      method: 'GET',
    }
  );
